
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46.798","height":"45.332","viewBox":"0 0 12.382 11.994","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.99 6A5.997 5.997 0 11-.004 6 5.997 5.997 0 0111.99 6","fill":"#e6e6e6"}}),_c('g',{attrs:{"fill":"none","stroke":"#4d4d4d","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":".388"}},[_c('path',{attrs:{"d":"M4.26 8.05H2.645V1.417h5.168V5.8a2.199 2.199 0 01.87-.11V1.339a.962.962 0 00-.962-.963H2.737a.962.962 0 00-.962.963v7.676c0 .531.43.962.962.962h.23a1.6 1.6 0 01-.044-.358c0-.793.58-1.444 1.337-1.57z"}}),_c('path',{attrs:{"d":"M10.8 8.44c-.042 0-.083.003-.123.006.043-.172.068-.351.068-.536a2.222 2.222 0 00-3.758-1.608 1.866 1.866 0 00-2.602 1.715v.014c-.043.004-.084.015-.126.022a1.593 1.593 0 00-1.338 1.57c0 .122.018.242.044.357.163.71.796 1.24 1.555 1.24h6.28a1.39 1.39 0 000-2.78zM10.07 7.67a1.645 1.645 0 00-1.959-1.257M7.78 3.16L6.42 4.52M3.84 4.84L2.652 6.028M7.82 1.96l-.77.77"}})])])
          )
        }
      }
    